import React from 'react'
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material'
import NavigateNextTwoToneIcon from '@mui/icons-material/NavigateNextTwoTone'
import { useNavigate, useLocation } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import { SupportAgentTwoTone } from '@mui/icons-material'

interface IProps {
    title?: string
}

function AppsHeader(props: IProps): JSX.Element {
    const { title } = props
    const location = useLocation()

    // Utils
    const navigate = useNavigate()

    return (
        <AppBar variant="elevation" elevation={0} position="sticky">
            <Toolbar>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="back"
                    sx={{ mr: 2 }}
                    onClick={() => {
                        if (location?.pathname === '/apps/pki') {
                            navigate('/')
                        } else {
                            navigate(-1)
                        }
                    }}
                >
                    <NavigateNextTwoToneIcon />
                </IconButton>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {title}
                </Typography>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="back"
                    sx={{ mr: 2 }}
                    onClick={() => navigate('/')}
                >
                    <HomeIcon />
                </IconButton>
                {!location?.pathname.includes('support') && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="back"
                        sx={{ mr: 2 }}
                        onClick={() => navigate('/support')}
                    >
                        <SupportAgentTwoTone />
                    </IconButton>
                )}
            </Toolbar>
        </AppBar>
    )
}

AppsHeader.defaultProps = {
    title: 'احرازهویت',
}

export default AppsHeader
